import { AxiosRequestConfig } from 'axios';
import {
  API_AUTH_FORGOT_PWD,
  API_AUTH_LOGIN,
  API_AUTH_LOGOUT,
  API_AUTH_RESET_PWD,
  API_AUTH_VALIDATE_TOKEN,
  API_POST_USER_CHANGE_PWD,
} from 'common/constants/apis';
import {
  CRASHLYTICS_AUTH_ERROR,
  CRASHLYTICS_LOGOUT_ERROR,
  CRASHLYTICS_VERIFY_OTP_ERROR,
} from 'common/constants/errors';
import { AuthResp, LoginPayload, ServerResponse } from 'common/interfaces';
import UILogger, { LogRecordType, LogSeverityType } from 'common/utils/logger';
import { DEFAULT_RETRY_CONFIG } from './../common/constants/index';
import httpClient from './config';

export const postLogin = (payload: LoginPayload): Promise<AuthResp> => {
  UILogger.info('Sending login request', payload);
  return httpClient
    .post(
      API_AUTH_LOGIN,
      {
        username: payload.username,
        password: payload.password,
      },
      DEFAULT_RETRY_CONFIG as AxiosRequestConfig,
    )
    .then((res) => {
      UILogger.log('Login response: ', res.data);
      return res.data;
    })
    .catch((error) => {
      UILogger.log(
        {
          recordType: LogRecordType.CRASHLYTICS,
          severity: LogSeverityType.ERROR,
          error,
          tag: CRASHLYTICS_VERIFY_OTP_ERROR,
        },
        'Error verifying Login OTP',
      );
      console.log('ERROR_RESP::::', error?.code);
      if (error.code == 'ERR_NETWORK') {
        return { status: { success: false, msg: 'Could not connect to server. Please try again later.' } } as AuthResp;
      }
      return { status: { success: false } } as AuthResp;
    });
};
export const checkUserSession = (): Promise<AuthResp | null> => {
  UILogger.log('AuthService: Checking user session, ');
  return httpClient
    .get(API_AUTH_VALIDATE_TOKEN)
    .then((res) => {
      UILogger.log('AuthService: Checking user session done, ', res.data);
      if (res.status === 200) {
        return res.data;
      }
      UILogger.log('##########Active user session......', res);
      return { status: { success: false } } as AuthResp;
    })
    .catch((error) => {
      if (error?.response?.status !== 401) {
        UILogger.log(
          {
            recordType: LogRecordType.CRASHLYTICS,
            severity: LogSeverityType.ERROR,
            error,
            tag: CRASHLYTICS_AUTH_ERROR,
          },
          'Error in checking usr session. Invalid session.',
          error,
        );
      }
      UILogger.log('Error in checking usr session. Invalid session. status:', error?.response?.status);
      return { status: { success: false } } as AuthResp;
    });
};

export const postUserLogout = (): Promise<ServerResponse> => {
  UILogger.log('Sending logout request to server..');
  UILogger.log({ recordType: LogRecordType.ALL, severity: LogSeverityType.INFO }, 'Logging out user');

  return httpClient
    .post(API_AUTH_LOGOUT, {})
    .then((res) => {
      UILogger.log('Logout response: ', res.data);
      return res.data;
    })
    .catch((error) => {
      UILogger.log(
        {
          recordType: LogRecordType.CRASHLYTICS,
          severity: LogSeverityType.ERROR,
          error,
          tag: CRASHLYTICS_LOGOUT_ERROR,
        },
        'Error in logout user',
        error,
      );
      return { status: { success: false } } as ServerResponse;
    });
};

export const postForgotPassword = (username: string): Promise<ServerResponse> => {
  UILogger.log('Sending forgot password request to server. username:{}.', username);

  return httpClient
    .get(API_AUTH_FORGOT_PWD.replace('{username}', username))
    .then((res) => {
      UILogger.log('forgot password response: ', res.data);
      return res.data;
    })
    .catch((error) => {
      UILogger.log(
        {
          recordType: LogRecordType.CRASHLYTICS,
          severity: LogSeverityType.ERROR,
          error,
          tag: CRASHLYTICS_LOGOUT_ERROR,
        },
        'Error in forgot password',
        error,
      );
      return { status: { success: false } } as ServerResponse;
    });
};

export const postResetPassword = (token: string, payload: LoginPayload): Promise<ServerResponse> => {
  UILogger.log('Sending Reset password request to server. token:', token);

  return httpClient
    .post(API_AUTH_RESET_PWD.replace('{token}', token), payload)
    .then((res) => {
      UILogger.log('Reset password response: ', res.data);
      return res.data;
    })
    .catch((error) => {
      UILogger.log(
        {
          recordType: LogRecordType.CRASHLYTICS,
          severity: LogSeverityType.ERROR,
          error,
          tag: CRASHLYTICS_LOGOUT_ERROR,
        },
        'Error in Reset password',
        error,
      );
      return { status: { success: false, msg: error.response.data.status.msg } } as ServerResponse;
    });
};

export const postChangePassword = (currentPassword: string, newPassword: string): Promise<ServerResponse> => {
  UILogger.log('Sending change password request to server. token:');

  return httpClient
    .post(API_POST_USER_CHANGE_PWD, {
      currentPassword,
      password: newPassword,
    })
    .then((res) => {
      UILogger.log('Change password response: ', res.data);
      return res.data;
    })
    .catch((error) => {
      UILogger.log(
        {
          recordType: LogRecordType.CRASHLYTICS,
          severity: LogSeverityType.ERROR,
          error,
          tag: CRASHLYTICS_LOGOUT_ERROR,
        },
        'Error in Change password',
        error,
      );
      return { status: { success: false } } as ServerResponse;
    });
};
